module.exports = __webpack_public_path__ + "img/hr-curved-rail-vertical-left-top-stone-path.497dd4ad.png";